import type { ReapproProductPreview } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchReapproCategoryPreview = async (
  storeId: number,
  categoryId: number,
  deliveryDate?: string,
) => {
  const response = await gozokiApiWithAuth.get<{ products: ReapproProductPreview[] }>(
    `/stores/${storeId}/reappro-categories/${categoryId}/preview`,
    { params: deliveryDate ? { deliveryDate } : undefined },
  )
  return response.data.products
}
